import ScreenLayout from 'components/common/ScreenLayout';
import React, {useState} from 'react';
import styled, {css} from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';
import DefaultText from 'components/common/DefaultText';
import {useRecoilValue} from 'recoil';
import {userInfoState} from 'utils/Atoms';
import {registerSalesManager} from 'function/api';
import DefaultButton from 'components/common/DefaultButton';
import CommonModal from 'components/common/CommonModal';
import ContainerHeader from 'components/common/ContainerHeader';
import PhoneNumberInput from 'components/common/PhoneNumberInput';
import {countryArray} from 'data/country';
import LabelInput from 'components/common/LabelInput';
import LabelSearchAddress from 'components/common/LabelSearchAddress';
import LabelSelectBox from 'components/common/LabelSelectBox';
import {nationalityOptions} from 'data/option';
import {getDevice} from 'utils/getDevice';

export default function RegisterSales() {
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});
  const device = getDevice();
  const [modal, setModal] = useState('');
  const userInfo = useRecoilValue(userInfoState);

  const [selectCountry, setSelectCountry] = useState(countryArray[0]);
  const [info, setInfo] = useState({
    phone: '',
    password: '',
    email: '',
    name: '',
    address: '',
    addressDetail: '',
    nationality: '',
    representativeIndustry: '',
    salesPartnerCompanyName: '',
  });
  // 비밀번호 보이기
  const [isVisiblePassword, setVisiblePassword] = useState<boolean>(false);

  const register = async () => {
    if (userInfo) {
      const result = await registerSalesManager({
        info,
        locale: selectCountry.languageCode,
        userInfo,
        setIsLoading,
        setErrorModal,
      });

      if (result) {
        setModal('complete');
      }
    }
  };

  const modalData: {[key: string]: any} = {
    complete: {
      title: '계정 등록 완료!',
      detail: '세일즈 매니저 계정 생성이 완료되었습니다.',
      firstButtonText: 'confirm',
      firstButtonStyle: {
        backgroundColor: colors.primary2,
      },
      firstButtonClick: () => {
        setModal('');
        window.location.reload();
      },
    },
  };

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      <Container>
        <ContainerHeader mainTitle="파트너 등록" />
        <Inner $device={device}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <DefaultText
              text="파트너 등록"
              textStyle={{
                fontSize: minmax(25),
                fontWeight: 'bold',
                borderBottom: `3px solid ${colors.primary}`,
                width: 'fit-content',
                textWrap: 'nowrap',
                height: 'fit-content',
              }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'right',
                width: '100%',
              }}>
              <DefaultButton
                text={'save'}
                buttonStyle={{
                  backgroundColor: colors.primary2,
                  width: 'fit-content',
                  padding: minmax(30),
                }}
                textStyle={{color: colors.white}}
                onClick={register}
              />
            </div>
          </div>
          <LabelInput
            labelText="파트너 회사명"
            type="text"
            value={info.salesPartnerCompanyName}
            setValue={(value: string) =>
              setInfo(prev => ({...prev, salesPartnerCompanyName: value}))
            }
          />
          <LabelInput
            labelText="managerName"
            type="text"
            value={info.name}
            setValue={(value: string) =>
              setInfo(prev => ({...prev, name: value}))
            }
          />
          <PhoneNumberInput
            label="phone"
            selectCountry={selectCountry}
            setSelectCountry={setSelectCountry}
            phoneNumber={info.phone}
            setPhoneNumber={e => setInfo(prev => ({...prev, phone: e}))}
            isRow
          />
          <LabelInput
            labelText="이메일"
            type="text"
            value={info.email}
            setValue={(value: string) =>
              setInfo(prev => ({...prev, email: value}))
            }
          />
          <LabelInput
            labelText={'enterPassword'}
            type="password"
            value={info.password}
            setValue={(e: any) => setInfo(prev => ({...prev, password: e}))}
            isVisiblePassword={isVisiblePassword}
            setVisiblePassword={setVisiblePassword}
          />
        </Inner>
      </Container>

      {modal !== '' && (
        <CommonModal
          title={modalData[modal]?.title}
          detail={modalData[modal]?.detail}
          firstButtonText={modalData[modal]?.firstButtonText}
          firstButtonStyle={modalData[modal]?.firstButtonStyle}
          secondButtonText={modalData[modal]?.secondButtonText}
          secondButtonStyle={modalData[modal]?.secondButtonStyle}
          firstButtonClick={modalData[modal]?.firstButtonClick}
          secondButtonClick={modalData[modal]?.secondButtonClick}
          closeModal={() => setModal('')}
        />
      )}
    </ScreenLayout>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${minmax(50)};
`;

const Inner = styled.div<{$device?: string}>`
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${minmax(40)};
  padding-top: 0;
  gap: ${minmax(40)};

  ${(props: any) =>
    props.$device === 'mobile' &&
    css`
      width: 90%;
      min-width: auto;
    `}
`;
